const ACTIONS = {
  onClose ({commit, dispatch, state}) {
    dispatch('toggleStopScroll', false)
    commit('isOpen', false)
  },
  onOpen ({commit, dispatch, state}, payload) {
    if (payload.stopScroll) {
      dispatch('toggleStopScroll', true)
    }
    commit('isOpen', true)
  },
  closeAll ({commit, dispatch, state, rootState}) {
    dispatch('menu/close', null, {root: true})
    dispatch('onClose')
  },
  open ({commit, dispatch, state}, payload) {
    const action = payload.action
    dispatch(action, payload.payload || null, {root: true})
    dispatch('onOpen', { stopScroll: payload.stopScroll || !typeof (payload.stopScroll === 'undefiend') || false })
  },
  close ({commit, dispatch, state}, payload) {
    const action = payload.action
    dispatch(action, payload.payload || null, {root: true})
    dispatch('onClose')
  },
  toggleStopScroll ({commit, state}, payload) {
    commit('isStopScroll', payload)
  }
}

export default ACTIONS



// WEBPACK FOOTER //
// ./src/store/modules/ui/actions.js